// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1QBCO","error":"Textarea_error__1jT3s","readonly":"Textarea_readonly__3O7ZR","disabled":"Textarea_disabled__35D3-"};